import { useLayoutEffect, useMemo } from 'react'
import ReactDOM from 'react-dom'
import Styles from './ToolbarOverlay.module.scss'

export const TOOLBAR_OVERLAY_CONTAINER_ID = 'toolbar-overlay-container-id'

export const PortalToolbarOverlay = () => {
  const renderContainer = useMemo(() => document.createElement('div'), [])

  useLayoutEffect(() => {
    const externalMount = document.getElementById(TOOLBAR_OVERLAY_CONTAINER_ID)
    externalMount?.appendChild(renderContainer)

    return () => {
      externalMount?.removeChild(renderContainer)
    }
  }, [renderContainer])

  return ReactDOM.createPortal(<div className={Styles.container}></div>, renderContainer)
}
